const specialList = {
  truncate: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  border: {
    border: '1px solid var(--sc-border-color)',
  },
  borderT: {
    borderTop: '1px solid var(--sc-border-color)',
  },
  borderB: {
    borderBottom: '1px solid var(--sc-border-color)',
  },
  borderL: {
    borderLeft: '1px solid var(--sc-border-color)',
  },
  borderR: {
    borderRight: '1px solid var(--sc-border-color)',
  },
  transitionTransform: {
    transitionProperty: 'transform',
    transitionDuration: '300ms',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  rotate180: {
    transform: 'rotate(180deg)',
  },
};
const specialKey = Object.keys(specialList);

function getSpecials({ specials }: { specials: string[] }) {
  const specialStyle = {};
  specials.forEach((key) => {
    Object.assign(specialStyle, specialList[key]);
  });
  return { specialStyle };
}

function isSpecial(key: string) {
  return specialKey.includes(key);
}

export { getSpecials, isSpecial };
